import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Textarea } from './../../models/editors/textarea.model';
import { Switch } from './../../models/editors/switch.model';

import { RealEstate } from './../../models/real-estates/real-estates.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { Dropdown } from './../../models/editors/dropdown.model';

import * as appConfig from './../../app.config';
import { Validators } from '@angular/forms';

@Component({
  selector: 'swb-real-estate-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class RealEstateDetailComponent extends FormDetailBase<RealEstate> implements OnInit {
  public url = 'estates';
  protected _redirect = './real-estate';

  public entity = new RealEstate({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název nemovitosti',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        wysiwyg: false,
        boundTo: 'custom_seo_data'
      }),
      new Contained({
        key: 'pdf_id',
        entityMultilang: this.entity,
        entityMultilangKey: 'pdf',
        label: 'Soubor se specifikací nemovitosti',
        apiUrl: 'files',
        upload: true,
        isMultilang: true
      }),
      new Switch({
        key: 'has_detail',
        label: 'Má detail',
        labelFalse: 'Nemá detail'
      }),
      new Textbox({
        key: 'price',
        label: 'Cena (Kč)',
        validators: [Validators.required],
        type: 'number'
      }),
      new Textarea({
        key: 'description',
        label: 'Popis',
        validators: [],
        isMultilang: true,
        wysiwyg: 'estate-detail',
        boundTo: 'has_detail',
        width: 2
      }),
      new Textbox({
        key: 'address',
        label: 'Adresa nemovitosti',
        validators: [Validators.required]
      }),
      new Dropdown({
        key: 'estate_type',
        label: 'Typ nemovitosti',
        options: appConfig.estateTypeOptions,
        defaultValue: 'flat',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'disposition',
        label: 'Dispozice',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'area',
        label: 'Rozloha [m2]',
        type: 'number',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'floor',
        validators: [Validators.required],
        label: 'Podlaží',
        type: 'number'
      }),
      new Switch({
        key: 'has_balcony',
        label: 'Má balkon',
        labelFalse: 'Nemá balkon'
      }),
      new Textbox({
        key: 'balcony_area',
        label: 'Rozloha balkonu [m2]',
        type: 'number',
        boundTo: 'has_balcony',
        defaultValue: 0
      }),
      new Switch({
        key: 'has_terace',
        label: 'Má terasu',
        labelFalse: 'Nemá terasu'
      }),
      new Textbox({
        key: 'terace_area',
        label: 'Rozloha terasy [m2]',
        type: 'number',
        boundTo: 'has_terace',
        defaultValue: 0
      }),
      new Switch({
        key: 'has_basement',
        label: 'Má sklep',
        labelFalse: 'Nemá sklep'
      }),
      new Textbox({
        key: 'basement_area',
        label: 'Rozloha sklepa [m2]',
        type: 'number',
        boundTo: 'has_basement',
        defaultValue: 0
      }),
      new Switch({
        key: 'has_garage',
        label: 'Má garážové stání',
        labelFalse: 'Nemá garážové stání'
      }),
      new Switch({
        key: 'has_parking',
        label: 'Má parkovací stání',
        labelFalse: 'Nemá parkovací stání'
      }),
      new Dropdown({
        key: 'enb',
        label: 'Energetická náročnost budovy (ENB)',
        options: appConfig.estateEnergyOptions,
        defaultValue: 'G'
      }),
      new Dropdown({
        key: 'estate_state',
        label: 'Štítek nemovitosti',
        options: appConfig.estateStateOptions,
        defaultValue: ''
      }),
      new Contained({
        key: 'estate_agent_id',
        entity: this.entity.estate_agent,
        label: 'Realitní makléř',
        apiUrl: 'estate-agents',
        upload: false,
        canCreate: true
      }),
      new Dropdown({
        key: 'estate_material',
        label: 'Materiál budovy',
        options: appConfig.estateMaterialOptions,
        defaultValue: 'brick',
        validators: [Validators.required]
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        entities: this.entity.files,
        files: this.entity.files,
        apiUrl: 'files',
        upload: true,
        imgOnly: false
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
